import { Badge } from '@/components/ui';
import { useTranslation } from 'react-i18next';
import type { TransactionStatus } from '@/types/admin-transaction';

function getVariant(status: TransactionStatus) {
  switch (status) {
    case 'charged':
    case 'renewed':
      return 'success';
    case 'identified':
    case 'setup_complete':
      return 'info';
    case 'failed':
      return 'destructive';
    case 'pending':
    case 'awaiting_identification':
    case 'awaiting_consent':
      return 'warning';
    case 'cancelled':
    case 'expired':
      return 'outline';
    default:
      return 'secondary';
  }
}

export function TransactionStatusBadge({ status }: { status: TransactionStatus }) {
  const { t } = useTranslation('transactions');
  return <Badge variant={getVariant(status)}>{t(`statuses.${status}`)}</Badge>;
}
